import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    paddingHorizontal: 30,
    paddingTop: 30,
    paddingBottom: 60,
  },
  heading: {
    textAlign: "center",
    fontSize: 16,
    fontFamily: "Helvetica-Bold",
    textTransform: "uppercase",
    paddingBottom: 20,
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "transparent",
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableColHeader: {
    width: "9.09%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#403E92",
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 4,
    textAlign: "center",
    backgroundColor: "#403E92",
    color: "white",
  },
  tableCol: {
    width: "9.09%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 4,
    textAlign: "center",
  },
  tableCell: {
    fontSize: 7,
  },
  footer: {
    position: "absolute",
    bottom: -20,
    left: 0,
    right: 0,
    textAlign: "right",
    fontSize: 8,
  },
});

const headers = [
  "Company Name",
  "Nature",
  "Email",
  "Supplier Code",
  "City",
  "Country",
  "Designated",
  "Currency",
  "Contact Person",
  "Contact",
  "Status",
];

const VendorPdf = ({ data = [] }) => (
  <Document title={"Supplier List"}>
    <Page size="A4" style={styles.page} orientation="landscape">
      <View style={styles.heading}>
        <Text>Supplier List</Text>
      </View>
      <View style={styles.table}>
        <View style={styles.tableRow} fixed>
          {headers.map((h) => (
            <View key={h} style={styles.tableColHeader}>
              <Text style={styles.tableCell}>{h}</Text>
            </View>
          ))}
        </View>
        {data && data.length > 0 ? (
          data.map((row, idx) => (
            <View key={row.id || idx} style={styles.tableRow} wrap={false}>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{row.company_name || "--"}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>
                  {row.company_nature || "--"}
                </Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>
                  {row.company_email || "--"}
                </Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>
                  {row.supplier_code || "--"}
                </Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{row.company_city || "--"}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>
                  {row.company_country || "--"}
                </Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>
                  {row.company_designation || "--"}
                </Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>
                  {row.currency?.currency_name || "--"}
                </Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>
                  {row.fname && row.lname ? `${row.fname} ${row.lname}` : "--"}
                </Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{row.contact || "--"}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{row.status || "--"}</Text>
              </View>
            </View>
          ))
        ) : (
          <View style={styles.tableRow}>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>No data</Text>
            </View>
          </View>
        )}
      </View>
      <View fixed>
        <Text
          style={styles.footer}
          render={({ pageNumber, totalPages }) =>
            `Page ${pageNumber} of ${totalPages}`
          }
        />
      </View>
    </Page>
  </Document>
);

export default VendorPdf;
